import { Link } from "react-router-dom";
import { Reveal, Divider, Overline } from "@/components/layout/Atoms";
import { useContent } from "@/contexts/ContentContext";
import { resolveMediaUrl } from "@/lib/api";

export default function Menus() {
    const c = useContent();
    const m = c.menus;
    const dm = c.daily_menus;

    return (
        <div data-testid="page-menus" className="container-k pt-10 pb-24">
            <div className="max-w-3xl">
                <Overline>{m.hero.overline}</Overline>
                <h1 className="mt-4 font-heading font-light text-5xl md:text-7xl leading-[1.0] text-kayama-ink">
                    {m.hero.h1_part1} <span className="italic text-kayama-pink">{m.hero.h1_italic}</span>{m.hero.h1_part2}
                </h1>
                <p className="mt-6 text-kayama-brown-2 text-lg max-w-2xl">{m.hero.subtitle}</p>
            </div>

            {dm?.enabled && dm?.items?.length > 0 && (
                <section className="mt-16" data-testid="daily-menus">
                    <div className="bg-kayama-brown text-kayama-cream p-10 md:p-14 relative overflow-hidden">
                        <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-kayama-pink/25 blur-3xl pointer-events-none" />
                        <div className="absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-kayama-gold/20 blur-3xl pointer-events-none" />
                        <div className="relative">
                            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                                <div>
                                    <Overline className="text-kayama-gold">{dm.overline}</Overline>
                                    <h2 className="mt-3 font-heading text-4xl md:text-5xl font-light leading-tight">
                                        {dm.title_part1} <span className="italic text-kayama-gold-light">{dm.italic}</span>{dm.title_part2}
                                    </h2>
                                </div>
                                <p className="text-kayama-cream/80 max-w-md text-sm leading-relaxed">{dm.subtitle}</p>
                            </div>

                            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
                                {dm.items.map((it, i) => {
                                    const msg = encodeURIComponent(`Bonjour Kayama Saveurs, je souhaite réserver le menu du jour : ${it.name}${it.date ? ` (${it.date})` : ""}.`);
                                    const waUrl = `https://wa.me/33766729529?text=${msg}`;
                                    return (
                                        <Reveal key={i} delay={i * 100}>
                                            <article className="bg-kayama-cream text-kayama-brown border border-kayama-gold/40 flex flex-col h-full" data-testid={`daily-menu-${i}`}>
                                                {it.image && (
                                                    <div className="h-48 overflow-hidden">
                                                        <img src={resolveMediaUrl(it.image)} alt={it.name} className="w-full h-full object-cover" />
                                                    </div>
                                                )}
                                                <div className="p-6 flex-1 flex flex-col">
                                                    <div className="flex items-center justify-between gap-2 mb-3">
                                                        <span className="overline">{it.date}</span>
                                                        {it.price && <span className="font-heading text-2xl text-kayama-pink">{it.price}</span>}
                                                    </div>
                                                    <h3 className="font-heading text-2xl text-kayama-brown leading-tight">{it.name}</h3>
                                                    <p className="mt-3 text-sm text-kayama-brown-2 leading-relaxed flex-1">{it.desc}</p>
                                                    <a
                                                        href={waUrl}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="mt-5 inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-body uppercase tracking-[0.18em] text-xs px-5 py-3 hover:bg-[#1ebe57] transition-colors rounded-none"
                                                        data-testid={`daily-menu-${i}-cta`}
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.05 4.91A10 10 0 0 0 12.04 2c-5.5 0-9.97 4.47-9.97 9.97 0 1.76.46 3.47 1.33 4.98L2 22l5.18-1.36a9.96 9.96 0 0 0 4.86 1.24h.01c5.5 0 9.97-4.47 9.97-9.97a9.92 9.92 0 0 0-2.97-7.0zM12.05 20.2h-.01a8.27 8.27 0 0 1-4.21-1.15l-.3-.18-3.08.81.82-3-.2-.31a8.26 8.26 0 0 1-1.27-4.4c0-4.57 3.72-8.29 8.29-8.29 2.21 0 4.29.86 5.86 2.43a8.23 8.23 0 0 1 2.43 5.87c0 4.57-3.72 8.29-8.29 8.29zm4.55-6.21c-.25-.13-1.48-.73-1.71-.81-.23-.08-.4-.13-.56.13-.17.25-.65.81-.79.97-.15.17-.29.18-.54.06-.25-.12-1.06-.39-2.01-1.24-.74-.66-1.24-1.48-1.39-1.73-.15-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.13-.56-1.35-.77-1.85-.2-.49-.41-.42-.56-.43-.15-.01-.31-.01-.48-.01-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.02 2.57.13.17 1.76 2.69 4.27 3.77.6.26 1.06.41 1.42.53.6.19 1.14.16 1.57.1.48-.07 1.48-.6 1.69-1.18.21-.58.21-1.07.15-1.18-.06-.11-.23-.17-.48-.3z"/></svg>
                                                        Réserver sur WhatsApp
                                                    </a>
                                                </div>
                                            </article>
                                        </Reveal>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <Divider />

            <div className="space-y-24 mt-16">
                {m.formulas.map((f, idx) => (
                    <Reveal key={idx} delay={idx * 100}>
                        <article className="bg-kayama-paper border border-kayama-line p-8 md:p-14 relative" data-testid={`menu-card-${idx}`}>
                            <div className="absolute top-0 left-0 w-1 h-full bg-kayama-pink" />
                            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-kayama-line pb-8">
                                <div>
                                    <Overline>Formule 0{idx + 1}</Overline>
                                    <h2 className="mt-2 font-heading text-4xl md:text-5xl font-light text-kayama-brown">{f.name}</h2>
                                    <p className="script text-3xl md:text-4xl mt-1">{f.baseline}</p>
                                </div>
                                <div className="md:text-right">
                                    <div className="text-kayama-pink font-heading text-3xl">{f.price}</div>
                                </div>
                            </div>

                            <div className="grid md:grid-cols-3 gap-10 mt-10">
                                {f.sections.map((s, si) => (
                                    <div key={si}>
                                        <h3 className="font-script text-3xl text-kayama-gold mb-4">{s.title}</h3>
                                        <ul className="space-y-5">
                                            {s.items.map((it, ii) => (
                                                <li key={ii}>
                                                    <div className="flex justify-between gap-3 font-heading text-lg text-kayama-brown">
                                                        <span>{it.name}</span>
                                                    </div>
                                                    <p className="text-sm text-kayama-brown-2 italic mt-1">{it.desc}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>

            <div className="mt-20 text-center">
                <p className="script text-4xl md:text-5xl">{m.bottom_script}</p>
                <Link to="/contact" data-testid="menus-cta-devis" className="btn-primary-k mt-6">{m.bottom_cta}</Link>
            </div>
        </div>
    );
}
